export default "__VITE_ASSET__DUTnJYhn__"